<template>
    <div class="footer">POWERED BY: <a href="https://www.linkedin.com/in/abramo-maffei-515553214/">ABRAMO MAFFEI</a> </div>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style scoped>
  .footer{
      height: 30px;
      width: 100%;
      background-color: rgb(0, 0, 0);
      color: rgb(168, 168, 168);
      text-align: center;
      font-size: 7pt;
      letter-spacing: 6px;
      line-height: 30px;
  }
</style>